/*
  A utility to wait for a bool to be thrown
 */
export class CompletablePromise {
    private _completed: boolean
    private resolvers: (() => void)[];

    constructor() {
        this._completed = false
        this.resolvers = []
    }

    public completed(): boolean {
        return this._completed
    }

    public mark_completed(): void {
        if (this._completed) {
            return
        }

        this._completed = true
        this.resolvers.forEach(pr => pr())
        this.resolvers = []
    }

    public async wait(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (this._completed) {
                resolve()
            } else {
                this.resolvers.push(() => resolve());
            }
        });
    }
}

/*
  A semaphore in promise form
 */
export class SemaphorePromise<T> {
    private queued_values: T[]
    private queued_resolvers: ((val: T) => void)[]

    constructor() {
        this.queued_values = []
        this.queued_resolvers = []
    }
    
    public push(val: T): void {
        if (this.queued_resolvers.length > 0) {
            // instant resolution
            const resolver = this.queued_resolvers.pop()
            if (resolver) {
                resolver(val)
            }
        } else {
            this.queued_values.unshift(val)
        }
    }

    public async pull(): Promise<T> {
        return new Promise((resolve, reject) => {
            if (this.queued_values.length > 0) {
                const val = this.queued_values.pop()!
                resolve(val)
            } else {
                this.queued_resolvers.unshift((val: T) => resolve(val));
            }
        });
    }
}

export function count_enum_elements(enumName: any): number {
    let count = 0
    for(let item in enumName) {
        if(isNaN(Number(item))) count++
    }
    return count
}

